const LoadingContainer = () => (
  <div className="loading-page-container">
    <wb-spinner theme="light" style={{ width: "32px", height: "32px" }} />
  </div>
);

export default LoadingContainer;
